import Service, { service } from '@ember/service';
import type NotificationsService from './notifications';
import type { NotificationOptions, ReimaginedToastOptions } from './notifications';
import type { ToastIntent } from '../color-tokens';

export type ToastOptions = ReimaginedToastOptions;

export default class ReimaginedToastService extends Service {
  @service declare notifications: NotificationsService;

  get toasts() {
    return this.notifications.toasts;
  }

  add = (
    message: string,
    optionsOrIntent?: NotificationOptions | ToastIntent,
    toastOptions?: ReimaginedToastOptions
  ) => {
    return this.notifications.add(message, optionsOrIntent, toastOptions);
  };

  success = (message: string, options?: ReimaginedToastOptions) => {
    return this.notifications.success(message, options);
  };

  error = (message: string, options?: ReimaginedToastOptions) => {
    return this.notifications.error(message, options);
  };

  warning = (message: string, options?: ReimaginedToastOptions) => {
    return this.notifications.warning(message, options);
  };

  info = (message: string, options?: ReimaginedToastOptions) => {
    return this.notifications.info(message, options);
  };

  dismiss = (id: string) => {
    return this.notifications.dismiss(id);
  };

  remove = (notification?: { id?: string }) => {
    return this.notifications.remove(notification);
  };

  removeAll = () => {
    return this.notifications.removeAll();
  };

  clear = () => {
    return this.notifications.clear();
  };
}
